// material
import {
  Container,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton
} from '@mui/material';
// hooks
import { useEffect } from 'react';
import useSettings from '../../hooks/useSettings';
// components
import Page from '../../components/Page';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { PATH_DASHBOARD } from '../../routes/paths';
import { checkRoles, ROLE_END_USER, ROLE_USER } from 'guards/CheckRoles';
import { generatePath, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SvgIconStyle from '../../components/SvgIconStyle';
import LoadingSpinner from '../../components/LoadingSpinner';
import { RootState, useSelector } from '../../redux/store';
import { Building } from '../../@types/model/user';
import * as React from 'react';
import axios from '../../utils/axios';
import { buildingState, getBuildings } from 'recoil/buildingState';
import { useRecoilValue, useSetRecoilState } from 'recoil';
// ----------------------------------------------------------------------

export default function BuildingList() {
  const { themeStretch } = useSettings();
  const { t } = useTranslation(['translation', 'custom']);
  const { loaded, user } = useSelector((state: RootState) => state.user);
  const buildings: Building[] = useRecoilValue(buildingState);
  const setBuildings = useSetRecoilState(buildingState);
  const role = checkRoles(user, ROLE_USER) ? '/' : '/end-user';
  const { workspace } = useSelector((state: RootState) => state.workspace);

  React.useEffect(() => {
    getBuildings().then((buildings: Building[]) => {
      setBuildings(buildings);
    });
  }, []);

  const pageTitle = workspace?.wsName === 'avia' ? t('naves') : t('buildings', { ns: 'custom' });
  return (
    <Page title={pageTitle}>
      <Container maxWidth={themeStretch ? false : 'xl'}>
        <HeaderBreadcrumbs
          heading={pageTitle}
          links={[
            { name: t('home'), href: role },
            { name: pageTitle, href: PATH_DASHBOARD.buildings.list }
          ]}
          action={
            <Button variant={'contained'} component={NavLink} to={PATH_DASHBOARD.buildings.new}>
              {t('add_building')}
            </Button>
          }
        />
        {!loaded ? (
          <LoadingSpinner />
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>{t('name')}</TableCell>
                <TableCell>{t('edit')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {buildings.map((building: Building) => {
                return (
                  <TableRow key={building.guid}>
                    <TableCell>{building.attributes.name}</TableCell>
                    <TableCell>
                      <IconButton
                        component={NavLink}
                        to={generatePath(PATH_DASHBOARD.buildings.edit, { guid: building.guid })}
                      >
                        <SvgIconStyle
                          src="/static/icons/giraf/edit.svg"
                          sx={{ width: '20px', height: '20px' }}
                        />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}
      </Container>
    </Page>
  );
}
